var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-page',{attrs:{"fetch-endpoint":_vm.fetchEndpoint}},[_c('page-header-new',{attrs:{"title":_vm.$t('Gamification_GamesHub_Page_Title')}}),_vm._v(" "),_c('page-content',[_c('games-to-purchase',{attrs:{"core-games":_vm.games}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309e813b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/gamification/pages/GamesCataloguePage.vue
// module id = null
// module chunks = 